import script from "./NotebookView.vue?vue&type=script&setup=true&lang=js"
export * from "./NotebookView.vue?vue&type=script&setup=true&lang=js"

import "./NotebookView.vue?vue&type=style&index=0&id=7336339e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7336339e"]])

export default __exports__